# GraphQL fragment to enable/disable calendar import

#import "../fragments/calendar-sync.graphql"

mutation SetCalendarSyncImportIsEnabled(
    $calendarSync: SetCalendarSyncImportIsEnabledInputFieldInput!
) {
    setCalendarSyncImportIsEnabled(input: {calendarSync: $calendarSync}) {
        calendarSync {
            ...CalendarSync
        }
    }
}
